import { render } from "./RegistrationNotice.vue?vue&type=template&id=51dfbc56&scoped=true"
import script from "./RegistrationNotice.vue?vue&type=script&lang=js"
export * from "./RegistrationNotice.vue?vue&type=script&lang=js"

import "./RegistrationNotice.vue?vue&type=style&index=0&id=51dfbc56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dfbc56"]])

export default __exports__